export const DatasetStatus = {
    DRAFT: "dataset.status_code.draft",
    PUBLISHED: "dataset.status_code.published"
}